<template>
    <Navbar :menus="menus" />

    <!-- <keep-alive max="0"> -->
    <keep-alive>
        <component :is="componentName"></component>
    </keep-alive>
    <!-- <component :is="componentName" :data="componentData"></component> -->

    <Footer :menus="menus" />
</template>

<script >
    import { ref, computed, defineAsyncComponent, onMounted } from "vue";
    import { useStore } from "vuex";
    import { useRoute } from "vue-router";

    // import router from "@/router";
    import { G, ajax } from "@/_common";

    import Navbar from "@/components/Navbar";
    import Footer from "@/components/Footer";

    export default {
        name: 'Main',
        components: {
            Navbar,
            Footer,
        },
        props: {
            data: {
                type: Object,
            },
        },
        setup(props) {
            const store = useStore();
            const route = useRoute();

            const menus = ref([]);

            const def_lang =
                route.params && route.params.lang ? route.params.lang : "az";

            const gpage = G.current.value;

            gpage.page = props.data ? props.data.page || "Default" : "Default";
            gpage.data[gpage.page] = props.data ? props.data.data || "" : "";

            onMounted(async () => {
                // Set default language
                store.commit("setLang", def_lang);

                // Get translations for static data
                await ajax
                    .get(store.getters.getTranslationsLink())
                    .then((e) => {
                        if (e && e.data) store.commit("setTranslations", e.data);
                    })
                    .catch((error) => {
                        // var res = error.response || {};
                    });

                await ajax
                    .get(store.getters.getMenusLink())
                    .then((e) => {
                        if (e && e.data && e.data.length) {
                            menus.value = e.data;
                        }
                    })
                    .catch((error) => {
                        var res = error.response || {};
                    });
            });

            // Set component for dynamic preview and redirect
            // const setComponent = (val) => {
            //     gpage.page = val;
            //     gpage.data[gpage.page] = {};

            //     route.push({ name: val });
            // };

            // const componentData = computed(() => {
            //     return gpage.data[gpage.page] || {};
            // });

            const componentName = computed(() => {
                const d = gpage.page;
                return defineAsyncComponent({
                    loader: () => import(`@/pages/${d}`),
                    suspensible: false,
                });
            });

            // return { componentData, componentName, setComponent };
            return { componentName, menus };
        },
    };
</script>

<style lang="scss" >
    #nprogress .bar {
        height: 4px;
    }
    #nprogress .spinner {
        right: auto;
        top: 50%;
        left: 50%;
    }
    .main-content {
        width: calc(100% - 280px);
    }
    @media (max-width: 576px) {
        .main-content {
            width: 100%;
        }
    }

    .e2-footer {
        background-image: url("@/assets/images/xudaferin_1.jpg");
        background-color: #ddd;
    }

    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
        // border-radius: 100px;
    }

    ::-webkit-scrollbar-thumb {
        background: #708AD4;
        // background-image: linear-gradient(180deg, #ddd 0%, #708AD4 99%);
        // box-shadow: inset 2px 2px 5px 0 rgba(#fff, 0.5);
        border-radius: 100px;
        border: 2px solid transparent;
        background-clip: content-box;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #3663df;
        border: 2px solid transparent;
        background-clip: content-box;
    }

    body{
    //     background-image: unset;
    //     background-size: cover;
    //     background-repeat: no-repeat;
    //     background-position: center center;
    //     background-attachment: fixed;
        scrollbar-color: #3663df #708AD4;
        scrollbar-width: auto;
        scrollbar-gutter: stable;
        transition: scrollbar-color 0.3s ease-out;
    }
</style>